export default function reducer(state = {
  sucursalesFV: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FV": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}